'use client';

import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useMeasure } from 'react-use';

import { useSetGlobalCssVariable } from '@/src/hooks/useSetGlobalCssVariable';

import styles from './StickyHeader.module.scss';

interface Props {
    children: ReactNode;
    className?: string;
}

export function StickyHeader({ children, className }: Props) {
    const [headerMeasureRef, { height: headerHeight }] = useMeasure<HTMLDivElement>();

    useSetGlobalCssVariable('--header-sticky-height', `${headerHeight}px`);

    return (
        <div className={classNames(className, styles.sticky)} ref={headerMeasureRef}>
            {children}
        </div>
    );
}
